/**
 * ProgressLoader Component
 */
import React, { Component, Fragment } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default class Loader extends Component {

   state = {
      comments: null
   }

   componentDidMount() {
     // this.getComments();
   }

   

   render() {
      const { comments } = this.state;

        const styles = {
            buttonProgress: {
                color: "green",
                position: 'fixed',
                top: '50%',
                left: '50%',
                marginTop: -15,
                marginLeft: -15,
            },
            wrapper: {
                width: "100%",
                height: "100%",
                zIndex: "99999",
                display: "block",
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                backgroundColor: "rgba(255,255,255,0.7)"
            },
        };
      return (
         <Fragment>
            <div className="dd" style={styles.wrapper}>
             <CircularProgress size={60}  style={styles.buttonProgress}/>
             </div>
         </Fragment>
      );
   }
}
